import React, {useEffect, useState} from 'react';

import { Link } from "react-router-dom";
import { i18n } from "translate/i18n";
import { formatDistanceToNow } from 'date-fns'
import { ptBR, enUS } from 'date-fns/locale'
import {getComments, getCommentsMentions} from "services/Comments.service";
import { Offcanvas } from "react-bootstrap";
import {useUser} from "store/providers/app";
import {useQuery} from "react-query";
import LoadingMessages from "components/Loading/messages";
import {compare} from "utils/actions"

function Notifications() {

    const { language } = useUser();
    let lang = ptBR

    if (language === 'en-US') {
        lang = enUS
    }

    const {user} = useUser()

    const [show, setShow] = useState(false);
    const [allComments, setAllComments] = useState([]);

    const fetchIndicators = () => {
        return getComments('indicators', '', user.id)
    }

    const fetchGoals = () => {
        return getComments('goals','', user.id)
    }

    const fetchMentions = () => {
        return getCommentsMentions('', user.id)
    }

    const commentsIndicators = useQuery('indicators', fetchIndicators, {refetchOnWindowFocus: true})
    const commentsGoals = useQuery('goals', fetchGoals, {refetchOnWindowFocus: true})
    const commentsMentions = useQuery('mentions', fetchMentions, {refetchOnWindowFocus: true})

    useEffect(() => {

        if(commentsMentions.isSuccess ) {

            //const indicators = commentsIndicators.data?.data.map(item => ({...item, type: 'indicator'}))
           // const goals = commentsGoals.data?.data.map(item => ({...item, type: 'goals'}))
           // const mentions = commentsMentions.data?.data.map(item => ({...item, type: 'goals'}))

            //let comments = [...indicators, ...goals]
            setAllComments(commentsMentions.data.sort(compare))
        }
    },[show])


    return (
        <li className="nav-item dropdown">
            <Link to="#" className="nav-link nav-alert pb-0" style={{marginTop: "2px"}} onClick={()=> setShow(!show)}>
                <span className="box-icon-messages">
                        <i className="bi bi-bell"/>
                </span>
            </Link>

            <Offcanvas placement="end" show={show} onHide={() => setShow(!show)} className="border-0">
                <Offcanvas.Header className="bg-theme" closeButton>
                    <Offcanvas.Title>
                        <span>{i18n.t('titlePage.notifications')}</span>
                    </Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body className="pt-2 pl-3 pr-3">

                    {/*{commentsIndicators?.isFetching && <LoadingMessages/>}*/}

                    {allComments?.length === 0 &&
                        <span className="dropdown-item dropdown-header">{i18n.t('messages.newMessages')}</span>
                    }

                    {!commentsIndicators.isFetching && allComments?.length > 0 &&
                        allComments.slice(0,7).map((item, index) => (
                            <div key={index}>
                                <span className="float-end text-muted text-sm ml-1">
                                     { formatDistanceToNow(
                                         new Date(item.created_at),
                                         {includeSeconds: true, locale: lang}
                                     )}
                                </span>

                                <p className="text-sm mb-2 mt-2 text-wrap" >
                                    <span className="text-primary">@{item?.username}</span>
                                    {item.type === 'goals' ? i18n.t('messages.complementGoal') : ' mencionou você no indicador '}
                                    <span className="fw-bolder mb-1 p-0">{item.commentable?.titulo || item.commentable?.titulo_meta}</span>
                                </p>

                                <hr className="dropdown-divider text-muted  mt-0 mb-0"/>
                            </div>
                        ))

                    }
                    <div className="d-grid text-center mt-3 mb-3">
                        <Link to="/notifications" className="btn btn-outline-primary">{i18n.t('messages.seeAll')}</Link>
                    </div>
                </Offcanvas.Body>
            </Offcanvas>
        </li>
    );
}

export default Notifications
